/* Weaving Creation - native accessibility toolbar. Persists choices in localStorage. */
(function () {
  var root = document.documentElement;
  var KEY = "wc-a11y";
  var CLASSES = ["a11y-contrast", "a11y-links", "a11y-readable", "a11y-motion"];
  var state = { classes: [], textStep: 0 };

  try { state = Object.assign(state, JSON.parse(localStorage.getItem(KEY) || "{}")); } catch (e) {}

  function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

  function applyText() {
    root.style.fontSize = state.textStep ? (100 + state.textStep * 12) + "%" : "";
  }
  function apply() {
    CLASSES.forEach(function (c) { root.classList.toggle(c, state.classes.indexOf(c) !== -1); });
    applyText();
  }
  apply(); // apply saved prefs as early as possible

  document.addEventListener("DOMContentLoaded", function () {
    var wrap = document.querySelector("[data-a11y]");
    if (!wrap) return;
    var panel = wrap.querySelector("[data-a11y-panel]");
    var toggle = wrap.querySelector("[data-a11y-toggle]");

    function setOpen(open) {
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }
    toggle.addEventListener("click", function () { setOpen(panel.hidden); });
    wrap.querySelector("[data-a11y-close]").addEventListener("click", function () { setOpen(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setOpen(false); });
    document.addEventListener("click", function (e) { if (!wrap.contains(e.target)) setOpen(false); });

    function markOptions() {
      wrap.querySelectorAll("[data-a11y-class]").forEach(function (b) {
        b.classList.toggle("is-on", state.classes.indexOf(b.getAttribute("data-a11y-class")) !== -1);
        b.setAttribute("aria-pressed", state.classes.indexOf(b.getAttribute("data-a11y-class")) !== -1 ? "true" : "false");
      });
    }
    markOptions();

    wrap.querySelectorAll("[data-a11y-class]").forEach(function (b) {
      b.addEventListener("click", function () {
        var c = b.getAttribute("data-a11y-class");
        var i = state.classes.indexOf(c);
        if (i === -1) state.classes.push(c); else state.classes.splice(i, 1);
        apply(); markOptions(); save();
      });
    });

    wrap.querySelectorAll("[data-a11y-text]").forEach(function (b) {
      b.addEventListener("click", function () {
        var d = b.getAttribute("data-a11y-text");
        if (d === "0") state.textStep = 0;
        else if (d === "+") state.textStep = Math.min(state.textStep + 1, 5);
        else state.textStep = Math.max(state.textStep - 1, 0);
        applyText(); save();
      });
    });

    wrap.querySelector("[data-a11y-reset]").addEventListener("click", function () {
      state = { classes: [], textStep: 0 };
      apply(); markOptions(); save();
    });
  });
})();
